import { render, staticRenderFns } from "./AppBottomBar.vue?vue&type=template&id=2a1392cf"
import script from "./AppBottomBar.vue?vue&type=script&lang=js"
export * from "./AppBottomBar.vue?vue&type=script&lang=js"
import style0 from "./AppBottomBar.vue?vue&type=style&index=0&id=2a1392cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports